import types from "@/data/types"

const ticketGenerateHelper = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
            return {
                enableGenerate: true,
                general: true,
                barcode: true,
                onlyMobile: true,
                additional: true,
                cloakify: true,
                addLetter: true,
            }
        case types.SG:
            return {
                enableGenerate: false,
                general: true,
                barcode: true,
                onlyMobile: true,
                additional: false,
                cloakify: true,
                addLetter: true,
            }
        case types.BALLPARK_APP:
            return {
                enableGenerate: true,
                general: true,
                barcode: true,
                onlyMobile: false,
                additional: false,
                cloakify: true,
                addLetter: false,
            }
        case types.TM_AM_SCRAPE:
            return {
                enableGenerate: true,
                general: false,
                barcode: false,
                onlyMobile: false,
                additional: false,
                cloakify: false,
                addLetter: false,
            }
        default:
            return {
                enableGenerate: true,
                general: false,
                barcode: false,
                onlyMobile: false,
                additional: false,
                cloakify: false,
                addLetter: false,
            }
    }
}

export default ticketGenerateHelper